import React, { useState, useEffect, useContext } from 'react';
import {format} from "date-fns";

import * as net from "../../../../lib/net";

import Dd_Sel from "../../../../lib/ui/dd_sel";
import Dt_Cal from "../../../../lib/ui/dt_cal";
import Saldo_Gst from "./saldo_gst";
import * as utils from "../../../../assets/utils";
import Tr01_Open from "../fkn/tr01_open";
import Wnd_Error from "../../../../lib/ui/wnd_error";
import Wnd_Ok from "../../../../lib/ui/wnd_ok";
import Wnd_Info from "../../../../lib/ui/wnd_info";
import Wnd_Confirm from "../../../../lib/ui/wnd_confirm";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

class Saldo_Obet extends React.Component {
  constructor(props, context) {
    super(props);

    this.dt_fd = React.createRef();
    this.dt_td = React.createRef();

    this.selitems = [
        {fkn: 'bevaka', text: 'BEVAKA'},
        {fkn: 'bokbild', text: 'BOKNINGSBILD'},
        {fkn: 'confirm', text: 'BEKRÄFTA'},
        {fkn: 'cancel', text: 'AVBOKA'}
    ];

    this.store = props.store;
    this.pms = props.store.pms;

    this.state = {};
    this.state.ynq = [];

    this.state.dta = [];
    this.state.rva = [];
    this.state.tra = [];

    this.state.tot = {};

    this.state.krubba = 0;
    this.state.ix = 0;
    this.state.boknr = "";
    this.state.datum = "";
    this.state.fdat = "";
    this.state.tdat = "";
    if(this.pms.base) {
        this.state.fdat = this.pms.base.fdat;
        this.state.tdat = this.pms.base.tdat;
    }

      this.state.msg = {};
      this.state.wnds = {};
    this.state.rvo = {};
    if(props.wnds) {
        if(props.wnds.boknr) this.state.boknr = props.wnds.boknr;
    }
  }
  componentDidUpdate() {
  }
  componentWillUnmount() {
  }
  componentDidMount() {
      ///this.dt_saldo();
  }

    dlg_style() {
      var css = {};
      //css.width = window.innerWidth * 0.8;
      //css.height = window.innerHeight * 0.8;
      return css;
    }
  th_style(id) {
      var css = {};
      css.cursor = "pointer";
      if(id == this.state.sortid) css.color = "#080";
      return css;
  }
  val_pris(val) {
      var s = "";
      if(val == 0) s = "0.00";
      if(val) s = val.cdipris();
      return s;
  };

    formchange (e) {
      const name = e.target.name;
      const value = e.target.value;
      var rvo = this.state.rvo;
      var na = name.split(".");
      rvo[na[0]][na[1]] = value;
      this.setState({rvo: rvo});
      //setState({[name]: value});
    }

    handleUserInput (e) {
      const name = e.target.name;
      const value = e.target.value;
      var user = this.state.user;
      user[name] = value;
      this.setState({user: user});
      //setState({[name]: value});
    }
    wnd_close = () => {
      if(this.props.close) {
          this.props.close(this.props.ctx);
      }
      else this.props.ctx.setState({ wnds: {} });
	};
  tb_style() {
      var css = {};
      css.height = window.innerHeight - 275;
      return css;
  }
    val_save (name, value) {
        //alert(JSON.stringify(name));
        //alert(JSON.stringify(value));
      var rvo = this.state.rvo;
      var na = name.split(".");
      rvo[na[0]][na[1]] = value;
      this.setState({rvo: rvo});
      //setState({[name]: value});
    }
  dt_fdat(e) {
    //alert(JSON.stringify(e));
    var dts = format(e, "yyyy-MM-dd");
    this.setState({ fdat: dts });
  }
  dt_tdat(e) {
      //alert(JSON.stringify(e));
    var dts = format(e, "yyyy-MM-dd");
    this.setState({ tdat: dts });
  }
  oneday(e) {
      //alert(JSON.stringify(e));
    //this.setState({ tdat: this.state.fdat });
    this.dt_td.current.updateDt(this.state.fdat);
  }
  addday(e) {
      //alert(JSON.stringify(e));
    //this.setState({ tdat: this.state.fdat });
    this.dt_fd.current.updateAdd();
    this.dt_td.current.updateAdd();
  }
  subday(e) {
      //alert(JSON.stringify(e));
    //this.setState({ tdat: this.state.fdat });
    this.dt_fd.current.updateSub();
    this.dt_td.current.updateSub();
  }
  gst_open(row) {
    //alert(JSON.stringify(row));
    var wnds = {};
    wnds.saldogst = true;
    wnds.boknr = row.boknr;
    wnds.glopnr = row.glopnr;
    this.setState({wnds: wnds});
  }
  tr_edit(row) {
    var self = this;
    var wnds = {};
    wnds.tropen = true;
    wnds.tro = row;
    this.setState({ wnds: wnds });
  }
  saldo_recov() {
    var self = this;

      var msg = { info: true, text: "Balanserar saldo ..."};
      self.setState({ msg: msg });

   var prm = {};
    prm.req = "pms.eko_recov.ekot_obet_recov";
    prm.fdat = this.state.fdat;
    prm.tdat = this.state.tdat;

    net.sio_req(prm)
    .then(function(ret){
        //alert(JSON.stringify(ret));

        if(ret.ok != "000") {
            self.setState({ msg: {} });
            return;
        }
        var dta = ret.dta;
        var tra = ret.tra;
        var tot = ret.tot;
        self.setState({ dta: dta, tra: tra, tot: tot, msg: {} }, function() {
            self.syncTb("trsTable");
        });
    })
    .catch(function(e){
        var txt = JSON.stringify(e);
    });
    }
  saldo_obet() {
    var self = this;
    //var fdatum = format(this.state.fdat, "yyyy-MM-dd");
    //var tdatum = format(this.state.tdat, "yyyy-MM-dd");
      var msg = { info: true, text: "Hämtar saldo ..."};
      //self.setState({ msg: msg });
    self.setState({ dta: [], tra: [], tot: {}, msg: msg });

    var prm = {};
    prm.req = "pms.eko_red.red_obet";
    prm.fdat = this.state.fdat;
    prm.tdat = this.state.tdat;

    net.sio_req(prm)
    .then(function(ret){
        //alert(JSON.stringify(ret));

        if(ret.ok != "000") {
            self.setState({ msg: {} });
            return;
        }
        var dta = ret.dta;
        var tra = ret.tra;
        var tot = ret.tot;
        self.setState({ dta: dta, tra: tra, tot: tot, msg: {} }, function() {
            self.syncTb("trsTable");
        });
    })
    .catch(function(e){
        var txt = JSON.stringify(e);
    });
    }
    syncTb(tb){
        if (!document.getElementById(tb)) {
            //alert("No tb");
            return;
        }
        var tbel = document.getElementById(tb);
        const thElements = tbel.getElementsByTagName('th'),
        tdElements = tbel.getElementsByTagName('td');

        for (let i = 0; i < thElements.length; i++) {
            const widerElement =
                    thElements[i].offsetWidth > tdElements[i].offsetWidth ? thElements[i] : tdElements[i],
            width = window.getComputedStyle(widerElement).width;
            thElements[i].style.width = tdElements[i].style.width = width;
        }
    }
   tb_sort(typ) {
      var self = this;
      //var rvs = self.state.rvs;
      var tra = self.state.tra;
      var sz = this.state.sz_val;

      tra.sort((a,b) => (a[typ] > b[typ]) ? 1 : ((b[typ] > a[typ]) ? -1 : 0));
      self.setState({ tra: tra, sortid: typ });
   }
  tb_filtr() {
      var self = this;
      var rvs = self.state.rvs;
      var sz = this.state.sz_val;

      if(sz.length < 1) {
        self.setState({ rva: rvs });
          return;
      }
      sz = sz.toUpperCase();
      var rva = rvs.filter(function(row) {
            var brc = false;
            if(row.company.toUpperCase().includes(sz)) brc = true;
            if(row.name.toUpperCase().includes(sz)) brc = true;
            return brc;
      });
      self.setState({rva: rva });
   }

  render() {
    //if(!this.props.show) return "";

    var title = this.props.title;
    if(!title) title = "Bokning";

	var html =
        <div className="mx_base">
        { this.props.backdrop ? <div className="mx_backdrop" /> : null }
        <div className="mx_dlg mx_90 flex-col" style={ this.dlg_style() }>
        <div className="mx_h01">
            <div>PERIOD OBETALT</div>
        </div>

            <div className="divider_orange hide"></div>

            <div className="flex-row">
                <div className="flex"></div>
            <div className="flex-row">
                  <div className="dt-btn-01" onClick={() => this.subday() } ><FontAwesomeIcon icon="minus" size="1x" /></div>
                  <Dt_Cal dts={ this.state.fdat } rp="1" ref={this.dt_fd} getValue={(e)=> this.dt_fdat(e)} />
                  <div className="dt-btn-01" onClick={() => this.oneday() } >1</div>
                  <Dt_Cal dts={ this.state.tdat } rp="1" ref={this.dt_td} getValue={(e)=> this.dt_tdat(e)} />
                  <div className="dt-btn-01" onClick={() => this.addday() } ><FontAwesomeIcon icon="plus" size="1x" /></div>
            </div>
                <div className="flex"></div>
                <button className="btn btn-hw-blue w150" onClick={() => this.saldo_recov() } aria-label="System" >
                    Balansera
                </button>
                <button className="btn btn-hw-blue w150" onClick={() => this.saldo_obet() } aria-label="System" >
                    Visa
                </button>
            </div>
             <div className="divider_green"></div>
            <div className="flex-row">
            <div className="flex"></div>
              <div className="flex-row">
                  <div className="px-2">Att Betala: { utils.toPris( this.state.tot.topay ) }</div>
                  <div className="px-2">Antal: { utils.toNum( this.state.tot.nrt ) }</div>
              </div>
               <div className="flex"></div>
            </div>
       <div className="mx_content flex">

        <div id="trsTable">
          <table className="table table-bordered table-hover" style={{marginBottom: "0px"}}>
                <thead>
                <tr>
                    <th style={ this.th_style("e0datum") } onClick={() => this.tb_sort("e0datum") }>Datum</th>
                    <th style={ this.th_style("e0rumsnr") } onClick={() => this.tb_sort("e0rumsnr") }>Rum</th>
                    <th style={ this.th_style("e0typ") } onClick={() => this.tb_sort("e0typ") }>Typ</th>
                    <th style={ this.th_style("e0tid") } onClick={() => this.tb_sort("e0tid") }>Tid</th>
                    <th style={ this.th_style("e0boknr") } onClick={() => this.tb_sort("e0boknr") }>Bok-Gst</th>
                    <th style={ this.th_style("e0text") } onClick={() => this.tb_sort("e0text") }>Text</th>
                    <th style={ this.th_style("e0antal") } onClick={() => this.tb_sort("e0antal") }>Antal</th>
                    <th style={ this.th_style("e0pris") } onClick={() => this.tb_sort("e0pris") }>Pris</th>
                    <th style={ this.th_style("e0tkn") } onClick={() => this.tb_sort("e0tkn") }>Tkn</th>
                </tr>
                </thead>
            </table>
            <div style={ this.tb_style() }>
          <table className="table table-bordered table-hover">
            <tbody>
                { this.state.tra.map((row, key) =>
                    <tr key={key} onDoubleClick={() => this.tr_edit(row) }>
                        <td>{ utils.toDate( row.e0datum ) }</td>
                        <td>{ utils.toRumsnr( row.e0rumsnr ) }</td>
                        <td>{ row.e0typ }</td>
                        <td>{ utils.toTid( row.e0tid ) }</td>
                        <td>{ row.e0boknr }-{ row.e0glopnr }</td>
                        <td>{ utils.toLang( row.e0text ) }</td>
                        <td>{ utils.toNum( row.e0antal ) }</td>
                        <td>{ utils.toPris( row.e0pris ) }</td>
                        <td>{ row.e0tkn }</td>
                    </tr>
                )}
                </tbody>
            </table>
        </div>
        </div>

            </div>

            <div className="mx_foot flex-row flex-space-between">
            <button className="btn btn-hw-red w250 ripple" onClick={() => this.wnd_close() } >
                STÄNG
            </button>
            <div className="flex-row">
            </div>
        </div>
      </div>
        { this.state.wnds.saldogst ? <Saldo_Gst wnds={this.state.wnds} ctx={this} store={this.props.store} backdrop={true}/> : null }
        { this.state.wnds.tropen ? <Tr01_Open wnds={this.state.wnds} ctx={this} store={this.props.store} backdrop={true}/> : null }

            <Wnd_Error msg={this.state.msg} ctx={this} />
            <Wnd_Ok msg={this.state.msg} ctx={this} />
            <Wnd_Info msg={this.state.msg} ctx={this} />
            <Wnd_Confirm msg={this.state.msg} ctx={this} />
    </div>
	;
	return html;
  };
}

export default Saldo_Obet;